import React from "react";
import { compose } from "redux";
import { Grid } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";
import { withStyles } from "@material-ui/core/styles";

import HeliReportInboundOutboundRow from "features/planner/report/helicopter/components/HeliReportInboundOutboundRow";

const ShoreOffshoreBoundHeader = ({ classes }) => (
  <Grid container className={classes.root}>
    <Grid item xs={8} className={classes.offshoreBound}>
      <HeliReportInboundOutboundRow>Outbound</HeliReportInboundOutboundRow>
    </Grid>
    <Grid item xs={4} className={classes.shoreBound}>
      <HeliReportInboundOutboundRow>Inbound</HeliReportInboundOutboundRow>
    </Grid>
  </Grid>
);

const styles = () => ({
  root: {
    borderBottom: "none",
    border: `1px solid ${grey[300]}`,
  },
  shoreBound: {
    background: "rgba(79, 149, 209, 0.5)",
  },
  offshoreBound: {
    background: "rgba(184, 209, 234, 0.5)",
  },
});

export default compose(withStyles(styles))(ShoreOffshoreBoundHeader);
